import { Chip } from "@mui/material";
import { useTranslations } from "use-intl";

export const RequiredLabel = () => {
  const t = useTranslations();

  return (
    <Chip
      sx={{
        position: "absolute",
        insetInlineEnd: "calc(var(--spacing)*4)",
        top: "calc(var(--spacing)*(-3))",
        bgcolor: "var(--color-semantic-warning-pressed-soft)",
        color: "var(--color-text-primary)",
        fontSize: "var(--text-xs)",
        fontWeight: "var(--font-weight-medium)",
        padding: "var(--spacing) calc(var(--spacing)*2)",
        borderRadius: "var(--radius-lg)",
        height: "calc(var(--spacing)*6)",
        lineHeight: "15px",
        "& .MuiChip-label": {
          padding: 0,
        },
      }}
      label={t("required")}
    />
  );
};
